// @flow
import 'babel-polyfill';
import * as React from 'react';
import { render } from 'react-dom';
import App from 'app/index';
import Customisation from 'app/generic';
import { enableEmailAsyncValidation } from 'app/validator/async';

type SignupConfig = {
    network: {
        id: string,
        name: string,
        welcomeMessage: ?string
    },
    url: {
        signUpComplete: string,
        logo: ?string
    },
    captchaSiteKey: string,
    captchaProvider: string,
    isAvailable?: boolean,
    validateEmail?: boolean,
    confirmEmail?: boolean,
    apiProtocol?: string,
    apiUrl?: string,
    merchantId?: string
};

const bootstrap = (config: SignupConfig) => {
    const CustomizedApp = App(
        Customisation, 
        config.network, 
        config.captchaSiteKey,
        config.isAvailable,
        config.captchaProvider,
        config.confirmEmail,
        config.apiProtocol,
        config.apiUrl,
        config.merchantId
    );
    if (config.validateEmail) {
        enableEmailAsyncValidation();
    }

    const appNode = document.getElementById('app');
    if (appNode) {
        render(
            <CustomizedApp
                signUpCompleteUrl={config.url.signUpComplete}
                logoUrl={config.url.logo}
                welcomeMessage={config.network.welcomeMessage}
                confirmEmail={config.confirmEmail}
                merchantId={config.merchantId}
            />,
            appNode
        );
    } else {
        throw new Error('Error initializing form!');
    }
};

window.bootstrap = bootstrap;
export default bootstrap;
